const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "30%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "10%"
  },
  {
    key: "avgCurrent",
    zh: "平均电流(A)",
    en: "Average Current(A)",
    width: "19%"
  },
  {
    key: "ratedCurrent",
    zh: "额定电流(A)",
    en: "Rated Current(A)",
    width: "18%"
  },
  {
    key: "percentage",
    zh: "过流率",
    en: "Percentage",
    width: "9%"
  }
]

export default columns